module.exports = __webpack_public_path__ + "img/player 3.da733ecf.png";